import axios from '@/utils/axios'
const api = {
    fetchUserAndProductDetail: '/company/task/applys/userAndProdectDetail',
    applys: '/company/task/applys',
    tableSticker: '/company/tasks/tableSticker'
}

/**
 * 到店任务详情
 * @returns {Promise<any>}
 */
export function fetchUserAndProductDetail (taskApplyId) {
    return new Promise((resolve, reject) => {
        axios.get(api.fetchUserAndProductDetail, { params: { taskApplyId } })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * 根据品牌ID获取桌贴信息
 * @returns {Promise<any>}
 */
export function fetchTableSticker (brandId) {
    console.log('fetchTableSticker', brandId)
    return new Promise((resolve, reject) => {
        axios.get(api.tableSticker, { params: { brandId } })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * arrive
 * @returns {Promise<any>}
 */
export function fetchArrive (taskApplyId, params) {
    return new Promise((resolve, reject) => {
        axios.put(`${api.applys}/${taskApplyId}/arrive`, { ...params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

// 系统生成优惠券接口
export function getCouponByRecordDetail (activitySendId) {
    return new Promise((resolve, reject) => {
        axios.get('/company/activity/getCouponByRecordId', { params: { activitySendId } })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// 查看优惠券核销记录
export function getCouponSendRecord () {
    return new Promise((resolve, reject) => {
        axios.get('/company/activity/getCouponSendRecord')
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// 核销奖品
export function fetchUseProduct (params) {
    return new Promise((resolve, reject) => {
        axios.put('/company/activity/useProduct', { ...params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
